import { CSSProperties, memo, ReactElement, ReactNode, useEffect } from "react";
import { Form, FormField, FormGroup, Header, Icon, Modal, ModalActions } from "semantic-ui-react";

// Component
import CardBuyBillingPackage from "react-lib/apps/MEH/CardBuyBillingPackage";

// Type
export type ModBuyBillingPackageProps = {
  // func & callback
  open: boolean;
  onClose: () => void;

  // CardBuyBillingPackageProps
  BillingAndPackageSequence: any;
  BillingCreditWallet: any;
  BillingCarts: any;
  onHistoryClick?: () => void;
  controller: any;
  runSequence: any;
  onEvent: any;
  setProp: any;
  languageUX: "en" | "th";
  onProceed?: () => void;
  termsAndConditionsList?: any;
};

const ModBuyBillingPackage = (props: ModBuyBillingPackageProps) => {
  useEffect(() => {
    if (props.BillingAndPackageSequence?.isBroadcast === false && props.BillingAndPackageSequence?.openPaidResultModal === false) {
      props.onClose();
    }
  }, [props.BillingAndPackageSequence]);

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      size="fullscreen"
    >
      <div style={{ margin: "1rem", textAlign: "right" }}>
        <Header dividing>
          <Icon
            name="close"
            onClick={props.onClose}
            style={{
              cursor: "pointer"
            }}
          />
        </Header>
      </div>

      <Form style={{ margin: "1rem", overflowY: "auto", overflowX: "hidden", height: "calc(90vh - 4rem)" }}>
        <CardBuyBillingPackage
          BillingAndPackageSequence={props.BillingAndPackageSequence}
          BillingCreditWallet={props.BillingCreditWallet}
          BillingCarts={props.BillingCarts}
          onHistoryClick={props.onHistoryClick}
          controller={props.controller}
          runSequence={props.runSequence}
          onEvent={props.onEvent}
          setProp={props.setProp}
          onProceed={props.onProceed}
          termsAndConditionsList={props.termsAndConditionsList}
          languageUX={props.languageUX}
        />
      </Form>
    </Modal>
  );
};

export default ModBuyBillingPackage;